import { useSetRecoilState, useRecoilState, useRecoilValue } from "recoil";
import {
  VisiblePlaylistClipsState,
  PlaylistClipsState,
  ActivePlaylistClipState,
} from "MVVM/State/embeddablePlaylist";

import { formatPlaylistClip } from "MVVM/Views/EmbeddablePlaylist/Utilities";

export const usePlaylistRefresh = () => {
  const [visiblePlaylistClips, setVisiblePlaylistClips] = useRecoilState(
    VisiblePlaylistClipsState,
  );
  const playlistClips = useRecoilValue(PlaylistClipsState);
  const setActivePlaylistClip = useSetRecoilState(ActivePlaylistClipState);

  const CLIPS_PER_BATCH = 5;

  const refreshPlaylist = () => {
    if (!visiblePlaylistClips || !playlistClips || playlistClips.length === 0) {
      return;
    }

    const allClipsVisible =
      visiblePlaylistClips.length === playlistClips.length;

    if (allClipsVisible) {
      const firstClip = formatPlaylistClip(playlistClips[0]);
      setActivePlaylistClip(firstClip);
    } else {
      const startIndex = visiblePlaylistClips.length;
      const endIndex = startIndex + CLIPS_PER_BATCH;
      const nextBatch = playlistClips.slice(startIndex, endIndex);

      setVisiblePlaylistClips((prev) => [...(prev || []), ...nextBatch]);

      const nextClipToPlay = formatPlaylistClip(nextBatch[0]);
      setActivePlaylistClip(nextClipToPlay);
    }
  };

  return { refreshPlaylist };
};
